import { Component, ViewChild, Inject, OnInit, OnDestroy, TemplateRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModuleInjectorService } from '../../../core/moduleinjector.service';
import {
  EmpusaMicroApp,
  EmpusaAuthenticationService,
  EmpusaThemeService,
} from '@empusa/empusa-core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from '../../../translations/paginator.i18n';
import { MatDialog } from '@angular/material/dialog';
import { ProfileComponent } from '../../profile/profile.component';
import { arrayBufferToBase64 } from '../../../core/util';
import { THEMES } from '../../../theme.config';
import { SelectableLanguaje } from '../../../model/selectable-languaje.interface';
import { TermsOfUseComponent } from '../../terms-of-use/terms-of-use.component';
import { EmpusaPortalAuthService } from 'src/app/services/auth.service';
import {
  PoseedorControllerService,
  PuntoRecogidaControllerService,
  GestorPtoRecogidaControllerService,
  AdheridoControllerService,
  BusquedaAdheridoDTO,
  GestoresResiduosControllerService,
  AcuerdoIndirectoControllerService,
  ComunicacionControllerService,
  ComunicacionFilterDTO,
  ComunicacionEstadoControllerService,
  ComunicacionEstadoDTO,
  NotificacionControllerService,
  CampanaFilterDTO,
  CampanacontrollerService,
  CampanaPoseedoresControllerService,
  CvfControllerService,
} from 'api-rest';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  providers: [ModuleInjectorService],
})
export class HomePage implements OnInit, OnDestroy {
  site: string;
  campana: any;
  cvfs: any = [];
  defaultSort: string = '';
  currentSort: string = '';
  pageNumber: number = 0;
  pageSize: number = 25;

  navbarTarget: string =
    window.innerWidth <= 1200 ? '#navbarSupportedContent' : '';
  /** list of modules availables */
  modules: EmpusaMicroApp[] = [];

  /** the current page selected */
  currentDynamicPage: string = '';

  /** the current selected lang */
  currentLang: string | undefined;

  bmsGrafana: string = this.environment.grafana;
  includeGrafana: boolean = false;

  @ViewChild('userPicture') userPictureImg: any;
  havePhoto: boolean = false;

  loading: boolean = true;
  selectableThemes: string[] = [];
  selectedTheme: string | null;
  privacyPolicyUrl: string | undefined;
  termsOfUse: boolean | undefined = false;
  selectableLanguajes: any;
  entityRoles: any[] = [];
  adheridosRoles: any[] = [];
  gestoresRoles: any[] = [];
  poseedoresRoles: any[] = [];
  puntosRecogidaRoles: any[] = [];
  gestorPuntosRecogidaRoles: any[] = [];
  acuerdosIndirectosRoles: any[] = [];
  comunicacionesPendientes: number = 0;
  intervalId: any;
  mensajeNotificacion = "";
  notificacionesVigentes:any[] = [];
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  @ViewChild('modalNotifTemplate') modalNotifTemplate!: TemplateRef<any>;

  constructor(
    private router: Router,
    private matPaginator: MatPaginatorIntl,
    private dialog: MatDialog,
    private paginator: PaginatorI18n,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService,
    private empusaThemeService: EmpusaThemeService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private translate: TranslateService,
    private empusaPortalAuthervice: EmpusaPortalAuthService,
    private adheridoService: AdheridoControllerService,
    @Inject('environment') private environment: any,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    private poseedorControllerService: PoseedorControllerService,
    private puntoRecogidaControllerService: PuntoRecogidaControllerService,
    private gestorPtoRecogidaControllerService: GestorPtoRecogidaControllerService,
    private acuerdoIndirectoControllerService: AcuerdoIndirectoControllerService,
    private comunicacionControllerSrv: ComunicacionControllerService,
    private comunicacionEstadoControllerSrv: ComunicacionEstadoControllerService,
    private notificacionService: NotificacionControllerService,
    private campanaService: CampanacontrollerService,
    private campanaPoseedoresService: CampanaPoseedoresControllerService,
    private cvfService: CvfControllerService,
  ) {
    /**  Site name */
    this.site = environment.site;

    /** Privacy url and terms of use*/
    this.privacyPolicyUrl = environment.privacyPolicyUrl;
    this.termsOfUse = environment.termsOfUse;

    /**Theme manager */
    this.selectableThemes = environment.selectableThemes;
    this.empusaThemeService.loadThemes(THEMES, this.environment.theme);
    if (this.selectableThemes && this.selectableThemes.length > 1)
      this.selectedTheme = this.empusaThemeService.setTheme(
        this.empusaThemeService.retrieveUserTheme()
      );
    else
      this.selectedTheme = this.empusaThemeService.setTheme(
        this.environment.theme
      );

    /** Languajes */
    this.currentLang = undefined;
    this.selectableLanguajes = this.environment.selectableLanguajes;
    this.selectableLanguajes.forEach((languaje: SelectableLanguaje) => {
      iconRegistry.addSvgIcon(
        languaje.svgIconName,
        sanitizer.bypassSecurityTrustResourceUrl(
          'assets/img/flags/' + languaje.svgIconFile
        )
      );
      if (!this.currentLang || languaje.locale == translate.currentLang) {
        this.currentLang = translate.currentLang;
      }
    });

    this.translate.onLangChange.subscribe((change) => {
      this.paginator.refresh(this.matPaginator);
      this.matPaginator.changes.next();
      this.currentLang = change.lang;
    });

    /** User photo */
    this.authService.isUserPhotoLoaded().subscribe((done) => {
      this.havePhoto = done;
      if (done) {
        this.userPictureImg.nativeElement.src =
          'data:image/jpeg;base64,' +
          arrayBufferToBase64(authService.user?.photo);
      }
    });

    this.router.navigate(['/']);

    /** Initialize permissions and access */
    let allModules: EmpusaMicroApp[] = (<any>window).empusa.modules;

    this.empusaPortalAuthervice.checkModulesPermissions(
      allModules,
      this.getCurrentPath()
    );

    this.empusaPortalAuthervice.includeGrafana.subscribe((value: boolean) => {
      this.includeGrafana = value;
    });

    this.empusaPortalAuthervice.loading.subscribe((value: boolean) => {
      this.loading = value;
    });

    this.empusaPortalAuthervice.modulesInMenu.subscribe(
      (modules: EmpusaMicroApp[]) => {
        this.modules = modules;
      }
    );

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 1200) {
        this.navbarTarget = '#navbarSupportedContent';
      } else {
        this.navbarTarget = '';
      }
    });

    this.empusaPortalAuthervice.getTempIdDataObservable.subscribe(
      (value: any) => {
        this.entityRoles = value.entityRoles;
        console.log('[HOME][ROLES] getTempIdDataObservable value:', value);
        console.log('[HOME][ROLES] entityRoles:', this.entityRoles);
        console.log(
          '[HOME][ROLES] resumen roles:',
          (this.entityRoles || []).map((r: any) => ({
            role: r?.role,
            type: r?.type,
            entity: r?.entity,
          }))
        );
        console.log('[HOME][ROLES] has AI-GESTOR:', this.canViewMenu('AI-GESTOR'));
        console.log('[HOME][ROLES] has AI_GESTOR:', this.canViewMenu('AI_GESTOR'));
        if (this.entityRoles) {
          this.adheridosRoles = this.entityRoles.filter(
            (entityRol) => entityRol.type == 'ADHERIDO' && entityRol.entity && entityRol.entity.length > 0
          );
          this.gestoresRoles = this.entityRoles.filter(
            (entityRol) =>
              entityRol.type == 'GESTOR_POSEEDOR' && entityRol.entity && entityRol.entity.length > 0
          );

          this.poseedoresRoles = this.entityRoles.filter(
            (entityRol) => entityRol.type == 'POSEEDOR' && entityRol.entity && entityRol.entity.length > 0
          );

          this.puntosRecogidaRoles = this.entityRoles.filter(
            (entityRol) =>
              entityRol.type == 'PUNTO_RECOGIDA' && entityRol.entity && entityRol.entity.length > 0
          );

          this.gestorPuntosRecogidaRoles = this.entityRoles.filter(
            (entityRol) =>
              entityRol.type == 'GESTOR_PUNTO_RECOGIDA' && entityRol.entity && entityRol.entity.length > 0
          );

          this.acuerdosIndirectosRoles = this.entityRoles.filter(
            (entityRol) =>
              this.isIndirectAgreementGestorRole(entityRol?.role) &&
              this.getEntityIds(entityRol?.entity).length > 0
          );

          if (this.adheridosRoles?.length > 0) {
            // Ahora adheridoRol.entity es un array de number
            const adheridoIds = this.adheridosRoles
              .flatMap((adheridoRol) => Array.isArray(adheridoRol.entity) ? adheridoRol.entity : [])
              .filter((id, index, self) => self.indexOf(id) === index); // eliminar duplicados
            const filter: BusquedaAdheridoDTO = {
              id: adheridoIds,
            };
            adheridoService
              .listarAdheridos({ page: 0, size: 100 }, filter)
              .subscribe((adheridos: any) => {
                if (adheridos.datos) {
                  adheridos.datos.forEach((adherido: any) => {
                    const adheridoRolObject = this.adheridosRoles.find(
                      (adheridoRol) =>
                      Array.isArray(adheridoRol.entity) &&
                      adheridoRol.entity.includes(adherido.id) &&
                      adheridoRol.role === 'AD-ADHERIDO'
                    );
                    if (adheridoRolObject) {
                      if (!adheridoRolObject.entityObject) {
                        adheridoRolObject.entityObject = [];
                      }
                      adheridoRolObject.entityObject.push(adherido);
                    }
                  });
                }
              });
          }
          if (this.gestoresRoles?.length > 0) {
            const gestorIds = this.gestoresRoles
              .flatMap((dataRol) => Array.isArray(dataRol.entity) ? dataRol.entity : [])
              .filter((id, index, self) => self.indexOf(id) === index); // eliminar duplicados
            const filter: any = {
              id: [gestorIds],
            };
            gestoresResiduosControllerService
              .findAll8(filter, { page: 0, size: 100 })
              .subscribe((gestor: any) => {
                if (gestor.datos) {
                  gestor.datos.forEach((gestor: any) => {
                    const gestorRolObject = this.gestoresRoles.find(
                      (gestorRol) =>
                        Array.isArray(gestorRol.entity) &&
                        gestorRol.entity.includes(gestor.id) &&
                        //gestorRol.entity == gestor.id &&
                        gestorRol.role === 'PO-GESTOR'
                    );
                    if (gestorRolObject) {
                      if (!gestorRolObject.entityObject) {
                        gestorRolObject.entityObject = [];
                      }
                      gestorRolObject.entityObject.push(gestor);
                    }
                    //gestorRolObject.entityObject = gestor;
                  });
                }
              });
          }
          if (this.poseedoresRoles?.length > 0) {
            const poseedorIds = this.poseedoresRoles
              .flatMap((dataRol) => Array.isArray(dataRol.entity) ? dataRol.entity : [])
              .filter((id, index, self) => self.indexOf(id) === index); // eliminar duplicados
            const filter: any = {
              id: [poseedorIds],
            };
            poseedorControllerService
              .findAll5(filter, { page: 0, size: 100 })
              .subscribe((poseedor: any) => {
                if (poseedor.datos) {
                  poseedor.datos.forEach((poseedor: any) => {
                    const poseedorRolObject = this.poseedoresRoles.find(
                      (poseedorRol) =>
                        Array.isArray(poseedorRol.entity) &&
                        poseedorRol.entity.includes(poseedor.id) &&
                        //poseedorRol.entity == poseedor.id &&
                        poseedorRol.role === 'PO-POSEEDOR'
                    );
                    if (poseedorRolObject) {
                      if (!poseedorRolObject.entityObject) {
                        poseedorRolObject.entityObject = [];
                      }
                      poseedorRolObject.entityObject.push(poseedor);
                    }
                    //poseedorRolObject.entityObject = poseedor;
                  });
                }
              });
          }
          if (this.puntosRecogidaRoles?.length > 0) {
            const puntosRecogidaIds = this.puntosRecogidaRoles
              .flatMap((dataRol) => Array.isArray(dataRol.entity) ? dataRol.entity : [])
              .filter((id, index, self) => self.indexOf(id) === index); // eliminar duplicados
            const filter: any = {
              id: [puntosRecogidaIds],
            };
            puntoRecogidaControllerService
              .findAllPtoRecogida(filter, { page: 0, size: 100 })
              .subscribe((puntosRecogida: any) => {
                if (puntosRecogida.datos) {
                  puntosRecogida.datos.forEach((puntosRecogida: any) => {
                    const puntosRecogidaRolObject =
                      this.puntosRecogidaRoles.find(
                        (puntosRecogidaRol) =>
                          Array.isArray(puntosRecogidaRol.entity) &&
                          puntosRecogidaRol.entity.includes(puntosRecogida.id) &&
                          //puntosRecogidaRol.entity == puntosRecogida.id &&
                          puntosRecogidaRol.role === 'PR-PUNTORECOGIDA'
                      );
                    if (puntosRecogidaRolObject) {
                      if (!puntosRecogidaRolObject.entityObject) {
                        puntosRecogidaRolObject.entityObject = [];
                      }
                      puntosRecogidaRolObject.entityObject.push(puntosRecogida);
                    }
                    //puntosRecogidaRolObject.entityObject = puntosRecogida;
                  });
                }
              });
          }
          if (this.gestorPuntosRecogidaRoles?.length > 0) {
            const gestorPuntosRecogidaIds = this.gestorPuntosRecogidaRoles
              .flatMap((dataRol) => Array.isArray(dataRol.entity) ? dataRol.entity : [])
              .filter((id, index, self) => self.indexOf(id) === index); // eliminar duplicados
            const filter: any = {
              id: [gestorPuntosRecogidaIds],
            };
            gestorPtoRecogidaControllerService
              .findAllGestorPtoRecogida(filter, { page: 0, size: 100 })
              .subscribe((gestorPuntosRecogida: any) => {
                if (gestorPuntosRecogida.datos) {
                  gestorPuntosRecogida.datos.forEach(
                    (gestorPuntosRecogida: any) => {
                      const gestorPuntosRecogidaRolObject =
                        this.gestorPuntosRecogidaRoles.find(
                          (gestorPuntosRecogidaRol) =>
                            Array.isArray(gestorPuntosRecogidaRol.entity) &&
                            gestorPuntosRecogidaRol.entity.includes(gestorPuntosRecogida.id) &&
                            //gestorPuntosRecogidaRol.entity == gestorPuntosRecogida.id &&
                            gestorPuntosRecogidaRol.role === 'PR-GESTOR'
                        );
                      if (gestorPuntosRecogidaRolObject) {
                        if (!gestorPuntosRecogidaRolObject.entityObject) {
                          gestorPuntosRecogidaRolObject.entityObject = [];
                        }
                        gestorPuntosRecogidaRolObject.entityObject.push(gestorPuntosRecogida);
                      }
                      //gestorPuntosRecogidaRolObject.entityObject = gestorPuntosRecogida;
                    }
                  );
                }
              });
          }

          if (this.acuerdosIndirectosRoles?.length > 0) {
            const acuerdoIds = this.acuerdosIndirectosRoles
              .flatMap((dataRol) => this.getEntityIds(dataRol?.entity))
              .filter((id, index, self) => self.indexOf(id) === index);

            const filter: any = {
              id: acuerdoIds,
            };

            this.acuerdoIndirectoControllerService
              .findAll3(filter, { page: 0, size: 100, sort: [] })
              .subscribe((acuerdos: any) => {
                if (acuerdos?.datos) {
                  acuerdos.datos.forEach((acuerdo: any) => {
                    const acuerdoRolObject = this.acuerdosIndirectosRoles.find(
                      (acuerdoRol) =>
                        this.getEntityIds(acuerdoRol.entity).includes(acuerdo.id) &&
                        this.isIndirectAgreementGestorRole(acuerdoRol.role)
                    );
                    if (acuerdoRolObject) {
                      if (!acuerdoRolObject.entityObject) {
                        acuerdoRolObject.entityObject = [];
                      }
                      acuerdoRolObject.entityObject.push(acuerdo);
                    }
                  });
                }
              });
          }
        }
      }
    );


  }
  ngOnInit(): void {
    this.obtenerComunicacionesPendientes();
    if (this.canViewMenu('PO-GESTOR') || this.canViewMenu('PO-POSEEDOR')) {
      this.obtenerVisibilidadCVF();
    }
    //Se actualiza el contador de comunicaciones cada 10 minutos
    this.intervalId = setInterval(() => {
      this.obtenerComunicacionesPendientes();
    }, 600000);
    
  }
  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  
  ngAfterViewInit(): void {
    this.openModal();
  }

  obtenerComunicacionesPendientes() {
    //Se piden las comunicaciones pendientes
    const filtroComunicacion: ComunicacionFilterDTO = {
      email: this.authService.user?.userMail
    };
    if (this.canViewMenu('ADM-COMUNICACIONES')) {
      //El estado 4 es pendiente de envalora
      filtroComunicacion.estado = { id: ['4'] };
    } else {
      //El estado 3 es pendiente de usuario
      filtroComunicacion.estado = { id: ['3'] };
    }
    this.comunicacionControllerSrv.findAllComunicacion1(filtroComunicacion, { page: 0, size: 500 })
      .subscribe((comunicaciones: any) => {
        if (comunicaciones.datos) {
          this.comunicacionesPendientes = comunicaciones.datos?.length;
        }
      });
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([uri]);
    });
  }

  canViewMenu(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canAccessAttachedApp(): boolean {
    return this.authService.can('adherido-menu', 'access-all');
  }

  canAccessAttachedAppSearch(): boolean {
    return this.authService.can('adherido', 'access-all');
  }

  canAccessPoseedoresAppMenu(): boolean {
    return this.authService.can('poseedores-menu', 'access');
  }

  canAccessPoseedoresSearchAccess(): boolean {
    return this.authService.can('poseedores', 'access-all');
  }

  canAccessPoseedoresGestorSearchAccess(): boolean {
    return this.authService.can('poseedores-gestor', 'access-all');
  }

  canAccessPoseedoresDiSearchAccess(): boolean {
    return this.authService.can('poseedores-di', 'access-all');
  }

  canAccessAdheridosDiSearchAccess(): boolean {
    return this.authService.can('adheridos-di', 'access-all');
  }

  canAccessPoseedoresAutoFacturaSearchAccess(): boolean {
    return this.authService.can('poseedores-facturas', 'access-all');
  }

  canAccessPackagingDeclaration(): boolean {
    return this.authService.can('dec_envases-menu', 'access-all');
  }

  canAccessAdministration(): boolean {
    return this.authService.can('administracion-menu', 'access-all');
  }

  canAccessCollectionPoints(): boolean {
    return this.authService.can('ptosrecogida-menu', 'access');
  }

  canAccessCollectionPointsSearch(): boolean {
    return this.authService.can('ptosrecogida', 'access-all');
  }

  canAccessCollectionPointsManagerSearch(): boolean {
    return this.authService.can('ptosrecogida-gestor', 'access-all');
  }

  canAccessCollectionPointsRequestsSearch(): boolean {
    return this.authService.can('ptosrecogida-solicitudes', 'access-all');
  }

  canAccessCPSelfInvoicesRequestsSearch(): boolean {
    return this.authService.can('ptosrecogida-facturas', 'access-all');
  }

  canAccessAcuerdoGestores(): boolean {
    return this.authService.can('acuerdo-indirecto', 'access-all') || this.canViewIndirectAgreementGestor();
  }

  private isIndirectAgreementGestorRole(role: string | undefined): boolean {
    if (!role) {
      return false;
    }
    const normalized = role.toUpperCase().replace(/_/g, '-');
    return normalized === 'AI-GESTOR';
  }

  canViewIndirectAgreementGestor(): boolean {
    return this.canViewMenu('AI-GESTOR') || this.canViewMenu('AI_GESTOR') || this.hasIndirectAgreementEntityRole() 
    || this.canViewMenu('AI-APORT-AUTOFACT') || this.canViewMenu('PO-APORT-EDIC-TOTAL-ENV-GEST');
  }

  private hasIndirectAgreementEntityRole(): boolean {
    return (this.entityRoles || []).some((entityRol: any) =>
      this.isIndirectAgreementGestorRole(entityRol?.role)
    );
  }
  canViewIndirectAgreementGestorFacturas(): boolean {
    return this.canViewMenu('AI-APORT-AUTOFACT') || this.canViewMenu('AI-ENV-GEST') || this.canViewMenu('AI-GESTOR')
    || this.canViewMenu('PO-APORT-EDIC-TOTAL-ENV-GEST') || this.canViewMenu('SUPER-ENV-GES') || this.canViewMenu('AI-ENV-CONS') ;
  }
  goToIndirectAgreementDetail(acuerdo: any): void {
    const acuerdoId = acuerdo?.id ?? acuerdo?.acuerdoId ?? null;
    this.router.navigate(['/managers-agreements/indirect-agreement-detail'], {
      queryParams: acuerdoId ? { acuerdoId } : undefined,
      state: { acuerdo },
    });
  }

  goToIndirectAgreementDetailById(acuerdoId: number): void {
    const filter: any = { id: [acuerdoId] };
    this.acuerdoIndirectoControllerService.findAll3(filter, { page: 0, size: 1, sort: [] }).subscribe({
      next: (res: any) => {
        const acuerdo = res?.datos?.[0];
        if (acuerdo) {
          this.goToIndirectAgreementDetail(acuerdo);
        }
      },
      error: () => {},
    });
  }

  getEntityIds(entity: any): number[] {
    const toId = (value: any): number | null => {
      if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
      }
      if (typeof value === 'string') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
      }
      if (value && typeof value === 'object') {
        return toId(value.id);
      }
      return null;
    };

    const values = Array.isArray(entity) ? entity : [entity];
    return values
      .map((value) => toId(value))
      .filter((id): id is number => id !== null);
  }

  canAccessGestoresRegistrados(): boolean {
    return this.authService.can('gestores-registrados-menu', 'access');
  }

  canAccessOpenSddrModule(){
    return this.authService.can('sddr-ca-menu', 'access-all');
    //return this.canViewMenu('SDDR-CA') || this.canViewMenu('SDDR-CA-ENV-GEST') || this.canViewMenu('SDDR-CA-ENV-CONS');
  }

  canAccessOpenSddrReuseRequest(){
    return this.authService.can('sddr-ca-solicitudes-reutilizacion', 'access-all');
  }

  canAccessOpenSddrWithDrawnRequest(){
    return this.authService.can('sddr-ca-solicitudes-retirada', 'access-all');
  }

  canAccessOpenSddrRemainRequest(){
    return this.authService.hasCurrentUserRole('SDDR-CA') && this.authService.can('sddr-ca-solicitudes-envase', 'access-all');
  }

  canAccessOpenSddrDiSearch(){
    return this.authService.can('sddr-ca-di', 'access-all');
  }

  canAccessOpenSddrAutofacturas(){
    return this.authService.can('sddr-ca-facturas', 'access-all');
  }

  canAccessCVFAppMenu(): boolean {
    const keycloakAuth = this.authService.can('cvf-menu', 'access-all');
    
     if(this.canViewMenu("PO-GESTOR") || this.canViewMenu("PO-POSEEDOR")){
      if(this.cvfs?.length > 0){
        return keycloakAuth;
      } else {
        return false;
      }
    }
    return keycloakAuth;
  }

  getCurrentPath(): string {
    let currentRoute = this.router.url;
    return currentRoute.split('/')[1];
  }

  onChangeTheme(theme: string) {
    this.selectedTheme = theme;
    this.empusaThemeService.setTheme(theme);
  }

  onChangeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('empusa.defaultLang', lang);
  }

  logout() {
    setTimeout(() => {
      this.authService._logout();
    }, 0);
    this.router.navigateByUrl('/');
  }

  profileUser() {
    let dialogAssign = this.dialog.open(ProfileComponent, {
      width: '680px',
    });
    dialogAssign.afterClosed().subscribe((result) => { });
  }

  openTermsOfUse() {
    const dialogRef = this.dialog.open(TermsOfUseComponent);

    dialogRef.afterClosed().subscribe((result) => { });
  }

  openComunications(): void {
    this.router.navigate(['/comunications/search']);
  }

  goToCvfSearch(type: string | null): void {
    if (type) {
      localStorage.setItem('cvfTypeFromRoute', type);
    } else {
      localStorage.removeItem('cvfTypeFromRoute');
    }
    this.redirectTo('/holders/holders-cvf-search');
  }

  goInitialPage(): void{
    this.router.navigate(['/initial-page']);
  }

  openModal(): void {
    this.dialog.open(this.modalTemplate, {
      width: '600px', 
      disableClose: true 
    });
  }

  buttonAceptarModal(){
    this.cargarNotificaciones();
  }

  cargarNotificaciones(){
    this.notificacionService.findAllByUser()
      .subscribe({
        next: (response) => {
          if(response){
            const fechaActual = new Date();
            fechaActual.setHours(0, 0, 0, 0);
            
            // Filtrar notificaciones vigentes
            this.notificacionesVigentes = response.filter((notificacion: any) => {
              const fechaDesde = new Date(notificacion.fechaDesde);
              const fechaHasta = new Date(notificacion.fechaHasta);
              
              fechaDesde.setHours(0, 0, 0, 0);
              fechaHasta.setHours(23, 59, 59, 999); 
              
              return fechaActual >= fechaDesde && fechaActual <= fechaHasta;
            });
            if(this.notificacionesVigentes.length > 0){
              this.openModalNotificaciones();
            }
          }
        },
        error: (err) => {
        },
    });
  }

  openModalNotificaciones(): void {
    if(this.notificacionesVigentes.length > 0){
      this.mensajeNotificacion = this.notificacionesVigentes[0].mensaje;
      this.notificacionesVigentes.shift();
      this.dialog.open(this.modalNotifTemplate, {
        width: '600px', 
        disableClose: true 
      });
    }
    
  }

  buttonAceptarModalNotificaciones(){
    if(this.notificacionesVigentes.length > 0){
      this.openModalNotificaciones();
    }
  } 

  obtenerVisibilidadCVF(){

    this.cvfService.menuCvfVisible().subscribe({
      next: (response: any) => {
        this.cvfs = response;
      },
      error: (err) => {
      }
    });
  }

  visualizarCVFGestor(): boolean{
    return this.cvfs.some((cvf: any) => cvf.poseedor === null);
  }

  visualizarCVFPoseedor(): boolean{
    return this.cvfs.some((cvf: any) => cvf.poseedor !== null);
  }
}
